'use client';

import { useContext } from 'react';

import { CareersEditContext } from '../contexts/careers-edit-provider';

export function useCareersEdit() {
	const context = useContext(CareersEditContext);

	if (!context) {
		throw new Error('useCareersEdit must be used within a CareersEditProvider');
	}

	return context;
}
